/* eslint-disable no-undefined */
import includes from 'lodash-es/includes';
import each from 'lodash-es/each';
import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import ProductTileReviews from './ProductTileReviews.jsx';
import ProductBadge from './ProductBadge.jsx';
import AdMindClick from '../AdMind/click';
import GiftCardProduct from '../../components/GiftCardProduct';

const ProductTile = (props) => {
  GiftCardProduct();

  const currency_symbol = window.theme.currency_symbol ? window.theme.currency_symbol : '$';
  const currency_iso = window.theme.currency_iso ? window.theme.currency_iso : 'USD';
  const yotpo_key =
    window.location.hostname === 'www.wndsr.dev'
      ? '41yw0gmFPCJm3ErG8NjBZAEKbxG3ptjvaYbMJTUB'
      : '5t2myNOMLouyXZtIpwsjsbejgY0mJ4kdf3QJ8JAE';

  const handleProductClick = (e) => {
    if (
      window.ShopifyAnalytics.meta.page.pageType === 'product' ||
      window.ShopifyAnalytics.meta.page.pageType === 'home'
    ) {
      if (e.target.attributes.src) {
        window.dataLayer.push({
          event: 'recommendation_click',
          product_name: e.target.dataset.productTitle,
          product_id: e.target.dataset.pid,
          recommendation_item_clicked: e.target.dataset.pid,
          page_type: window.ShopifyAnalytics.meta.page.pageType,
        });
        console.log('recommendation_click', e.target.dataset.productTitle, e.target.dataset.pid);
      } else {
        window.dataLayer.push({
          event: 'quick_shop_click',
          product_name: e.target.dataset.title,
          product_id: e.target.dataset.pid,
          product_to_quick_shop: e.target.dataset.pid,
          page_type: window.ShopifyAnalytics.meta.page.pageType,
        });
        console.log('quick_shop_click', e.target.dataset.title, e.target.dataset.pid);
      }
    }

    if (!props.shouldReportClickToAdmind) {
      return;
    }

    let listName = false;
    const currentTarget = e.currentTarget;
    const collectionName = currentTarget.closest('[data-collection]');
    if (collectionName) {
      listName = collectionName.dataset.collection;
      sessionStorage.setItem('rec_list_name', listName);
    }

    const position = props.positionInSerp ? props.positionInSerp : 1;

    AdMindClick({
      ...props,
      position,
      list_name: listName,
    });
  };

  const availableVariants = props.variants.filter((variant) => {
    return variant.Sellable && variant.imgs;
  });

  if (availableVariants.length === 0) {
    return null;
  }

  const variantsWithMatchingColorFamily = props.variants.filter((variant) => {
    return includes(props.narrowColorFamilies, variant['Isp-color-family']);
  });

  const getInitialThumb = () => {
    const firstMatchingColorFamilyThumb =
      variantsWithMatchingColorFamily.length > 0 ? variantsWithMatchingColorFamily[0].imgs : null;

    if (props.selectedColor) {
      const correctVariant = availableVariants.find((variant) => {
        const selectedColorUpper = props.selectedColor.toUpperCase();
        const variantColorUpper = variant.Color.toUpperCase();
        return selectedColorUpper === variantColorUpper;
      });
      if (correctVariant) {
        return correctVariant.image_url;
      }
    }

    const thumb = firstMatchingColorFamilyThumb ? firstMatchingColorFamilyThumb : availableVariants[0].imgs;

    return thumb;
  };

  const initialThumb = getInitialThumb();
  const [currentThumbUrl, setCurrentThumbUrl] = useState(initialThumb);
  const [currentVariantBarcode, setCurrentVariantBarcode] = useState(props.variants[0].Barcode);

  const imagesForVariant =
    props.product_images && props.product_images.length > 0
      ? props.product_images.filter((url) => {
          return includes(url, currentVariantBarcode);
        })
      : [];

  const [loading, setLoading] = useState(true);

  const truncatedTitle = useRef(null);

  const isPlaceholder = props.title.indexOf('PLACEHOLDER') > -1 || props.title.indexOf('CLEARANCE') > -1;

  const getOriginalProductUrl = () => {
    if (!isPlaceholder) {
      return props.product_url;
    }

    if (
      availableVariants &&
      availableVariants.length > 0 &&
      availableVariants[0]['Product-sku'] &&
      availableVariants[0]['Product-sku'].indexOf('|') > -1
    ) {
      return `/products/${availableVariants[0]['Product-sku'].split('|')[1]}`;
    }

    if (props.sku && props.sku.indexOf('|') > -1) {
      return `/products/${props.sku.split('|')[1]}`;
    }

    return null;
  };

  const originalProductUrl = getOriginalProductUrl();

  const getProductUrl = () => {
    if (!originalProductUrl) {
      if (props.collectionUrl) {
        return `${props.collectionUrl}${props.product_url}`;
      } else {
        return props.product_url;
      }
    }

    if (props.collectionUrl) {
      return `${props.collectionUrl}${originalProductUrl}`;
    } else {
      return originalProductUrl;
    }
  };

  const productUrl = getProductUrl();

  const productTileClasses = classNames({
    ProductTile: true,
    'ProductTile--react': true,
    'ProductTile--loading': loading,
    'ProductTile--mobile-stack-stars': props.mobileStackStars,
  });

  const availableColors =
    props.options && props.options.Color
      ? props.options.Color.filter((color) => {
          const avaialbleVariantsWithColor = props.variants.filter((variant) => {
            return variant.Sellable && variant.imgs && variant.imgs.length > 0 && variant.Color === color;
          });

          return avaialbleVariantsWithColor.length > 0;
        })
      : 0;

  const numColors = availableColors ? availableColors.length : [];

  const getFirstVariantWithColor = (color) => {
    for (let i = 0; i < props.variants.length; i++) {
      const variant = props.variants[i];

      if (variant.Color === color) {
        return variant;
      }
    }

    return null;
  };

  const getFirstVariantWithColorBarcode = (color) => {
    for (let i = 0; i < props.variants.length; i++) {
      const variant = props.variants[i];

      if (variant.Color == color) {
        return variant.Barcode;
      }
    }

    return null;
  };

  const getFirstVariantImageWithBarcodeInd = (color) => {
    const ind = props.options.Color.indexOf(color);

    if (ind >= 0 && props.options && props.options.Barcode && props.options.Barcode.length >= ind - 1) {
      return props.options.Barcode[ind];
    }

    return null;
  };

  const getFirstVariantImageWithColor = (color) => {
    const ind = props.options.Color.indexOf(color);

    if (ind >= 0 && props.options && props.options.imgs && props.options.imgs.length >= ind - 1) {
      return props.options.imgs[ind];
    }

    return null;
  };

  const getVariantFromColor = (color) => {
    // Skip the first variant for dataLayer impression push, as it is already displayed on the page.
    if (props.variants[0].Color === color) {
      return null;
    }

    for (let i = 1; i < props.variants.length; i++) {
      const variant = props.variants[i];

      if (variant.Color === color) {
        return variant;
      }
    }

    return null;
  };

  const clearanceProductData =
    props.description && props.description.indexOf('{"handle":') > -1
      ? JSON.parse(`{"handle":${props.description.split('{"handle":')[1]}`)
      : null;

  const handleVariantColorMouseOver = (e, color) => {
    const firstVariantImageUrl = getFirstVariantImageWithColor(color);
    const firstVariant = getFirstVariantWithColor(color);

    if (e) {
      const currentTarget = e.currentTarget;
      const parentNode = e.currentTarget.parentNode;

      parentNode.childNodes.forEach((child) => {
        child.classList.remove('active');
      });

      currentTarget.classList.add('active');
    }

    if (firstVariantImageUrl) {
      setCurrentThumbUrl(firstVariantImageUrl);
      const selectedVariant = getVariantFromColor(color);
    }

    if (firstVariant) {
      setCurrentVariantBarcode(firstVariant.Barcode);
    }
  };

  const checkSoldOutClearanceColors = (swatch_color) => {
    const colorInventories = {};
    const variantClearanceValues = {};

    for (let i = 0; i < props.variants.length; i++) {
      const item = props.variants[i];

      const cents = String(item.Price).slice(-2);
      if (variantClearanceValues[item.Color]) {
        if (!(cents === '97') && variantClearanceValues[item.Color]) {
          variantClearanceValues[item.Color] = cents === '97';
        }
      } else {
        variantClearanceValues[item.Color] = cents === '97';
      }

      if (colorInventories[item.Color]) {
        if (item.Sellable && !colorInventories[item.Color]) {
          colorInventories[item.Color] = item.Sellable;
        }
      } else {
        colorInventories[item.Color] = item.Sellable;
      }
    }

    return !variantClearanceValues[swatch_color] || colorInventories[swatch_color];
  };

  let minAvaliablePrice = 0;
  let maxAvaliablePrice = 0;
  let firstAvaliablePrice = 0;
  let minIndex = 0;

  // eslint-disable-next-line
  each(props.variants, (variant, index) => {
    let variant_price = false;

    if (variant.Price) {
      variant_price = variant.Price;
    } else if (variant.price) {
      variant_price = variant.price;
    }

    if (variant_price && parseFloat(variant_price.replace(`${currency_iso}:`, '')).toFixed(2) > 0 && variant.Sellable) {
      if (firstAvaliablePrice === 0) {
        firstAvaliablePrice = parseFloat(variant_price.replace(`${currency_iso}:`, '')).toFixed(2);
      }
      if (
        minAvaliablePrice === 0 ||
        Number(minAvaliablePrice) > Number(parseFloat(variant_price.replace(`${currency_iso}:`, '')).toFixed(2))
      ) {
        minAvaliablePrice = parseFloat(variant_price.replace(`${currency_iso}:`, '')).toFixed(2);
        minIndex = index;
      }
      if (
        maxAvaliablePrice === 0 ||
        Number(maxAvaliablePrice) < Number(parseFloat(variant_price.replace(`${currency_iso}:`, '')).toFixed(2))
      ) {
        maxAvaliablePrice = parseFloat(variant_price.replace(`${currency_iso}:`, '')).toFixed(2);
      }
    }
  });

  if (firstAvaliablePrice === 0) {
    firstAvaliablePrice = props.price;
  }
  if (minAvaliablePrice === 0) {
    minAvaliablePrice = firstAvaliablePrice;
    maxAvaliablePrice = firstAvaliablePrice;
  }

  // check first variant is available, if not change default picture
  if (
    !checkSoldOutClearanceColors(props.variants[0].Color) &&
    currentThumbUrl ===
      props.variants[0].imgs
        .replace('_large', '')
        .replace('_600x', '')
        .replace('.jpg', '_500x750_crop_center.jpg')
        .replace('.webp', '_500x750_crop_center.webp')
  ) {
    for (let i = 0; i < props.variants.length; i++) {
      if (checkSoldOutClearanceColors(props.variants[i].Color)) {
        setCurrentThumbUrl(
          props.variants[i].imgs
            .replace('_large', '')
            .replace('_600x', '')
            .replace('.jpg', '_500x750_crop_center.jpg')
            .replace('.webp', '_500x750_crop_center.webp'),
        );
      }
    }
  }

  let priceContainer = '';

  const template = document.body.getAttribute('data-template');

  const currency_alternate_iso =
    currency_symbol === '$' && currency_iso !== 'USD' && currency_iso !== 'HKD' ? currency_iso : '';

  if (minAvaliablePrice !== maxAvaliablePrice) {
    priceContainer = (
      <p
        className="ProductTile__price"
        data-product-tile-price
        role="region"
        tabIndex={0}
        aria-label={`Price: ${currency_alternate_iso} ${window.formatter.format(
          minAvaliablePrice,
        )} - ${currency_alternate_iso} ${window.formatter.format(maxAvaliablePrice)}`}
      >
        {currency_iso !== 'USD' && <span>Starting at: </span>}
        <span className={props.price_compare_max > props.price ? 'sale' : ''}>
          {currency_alternate_iso}
          {window.formatter.format(minAvaliablePrice)} - {currency_alternate_iso}
          {window.formatter.format(maxAvaliablePrice)}
        </span>
        <br />
      </p>
    );
  } else if (template === 'product' && props.variants[0].price === props.variants[0].compare_at_price) {
    priceContainer = (
      <p
        className="ProductTile__price"
        tabIndex={0}
        aria-label={`Price: ${currency_alternate_iso} ${window.formatter.format(minAvaliablePrice)}`}
        data-product-tile-price
      >
        {currency_alternate_iso}
        {window.formatter.format(minAvaliablePrice)}
      </p>
    );
  } else if (
    (template === 'product' && props.price < props.compare_at_price) ||
    Number(props.price_compare_max) > Number(props.price)
  ) {
    priceContainer = (
      <div
        className="ProductTile__price"
        role="region"
        tabIndex={0}
        aria-label={`Price: ${currency_alternate_iso} ${window.formatter.format(
          props.price,
        )}, Before: ${currency_alternate_iso} ${window.formatter.format(
          props.price_compare_max,
        )}, Discount: ${Math.round(((props.price_compare_max - props.price) / props.price_compare_max) * 100)}% off`}
        data-product-tile-price
      >
        <div className="sale__container">
          <span className="sale">
            {currency_alternate_iso}
            {window.formatter.format(props.price)}
          </span>{' '}
          <span className="original">
            {currency_alternate_iso}
            {window.formatter.format(props.price_compare_max)}
          </span>
        </div>
        <div className="dicount__container">
          <span className="discount">
            {Math.round(((props.price_compare_max - props.price) / props.price_compare_max) * 100)}% off
          </span>
        </div>
      </div>
    );
  } else {
    priceContainer = (
      <p
        className="ProductTile__price"
        aria-label={`Price: ${currency_alternate_iso} ${window.formatter.format(minAvaliablePrice)}`}
        role="region"
        tabIndex={0}
        data-product-tile-price
      >
        {currency_alternate_iso}
        {window.formatter.format(minAvaliablePrice)}
      </p>
    );
  }

  const productTitle = props.title.replace('PLACEHOLDER - ', '').replace('CLEARANCE - ', '');

  let productHash = '';

  if (props.collectionUrl) {
    productHash = `#from_smart_nav|${props.positionInSerp}`;
  } else if (props.searchTerm) {
    productHash = `#from_search|${props.positionInSerp}`;
  }

  const getPrimaryImage = () => {
    if (imagesForVariant && imagesForVariant.length > 0) {
      return imagesForVariant[0]
        .replace('_large', '')
        .replace('_600x', '')
        .replace('.jpg', '_500x750_crop_center.jpg')
        .replace('.webp', '_500x750_crop_center.webp');
    }

    return currentThumbUrl
      .replace('_large', '')
      .replace('_600x', '')
      .replace('.jpg', '_500x750_crop_center.jpg')
      .replace('.webp', '_500x750_crop_center.webp');
  };

  let newProductUrl = productUrl.replace('https://www.windsorstore.com', `https://${window.location.hostname}`);

  return (
    <div
      onClick={handleProductClick}
      className={productTileClasses}
      data-product-title={props.title}
      data-product-id={props.pid}
    >
      {currentThumbUrl && (
        <div
          className="ProductTile__image"
          data-product-tile-image
          data-store-scroll-position
          title={props.title}
          data-product-title={props.title}
          data-product-id={props.pid}
        >
          <a href={`${newProductUrl}${productHash}`} target="_self">
            {loading && (
              <img
                data-src={getPrimaryImage()}
                className="lazyload"
                alt={props.thumb_alt ? props.thumb_alt : props.title}
                data-product-id={props.pid}
                onLoad={() => {
                  setLoading(false);
                }}
              />
            )}
            {loading && imagesForVariant && imagesForVariant.length > 1 && (
              <img
                className="hover-image lazyload"
                alt={props.thumb_alt ? props.thumb_alt : props.title}
                width="500"
                height="750"
                data-product-id={props.pid}
                data-product-title={props.title}
                data-src={imagesForVariant[1]
                  .replace('_large', '')
                  .replace('_600x', '')
                  .replace('.jpg', '_500x750_crop_center.jpg')
                  .replace('.webp', '_500x750_crop_center.webp')}
              />
            )}
            {!loading && (
              <img
                src={getPrimaryImage()}
                className="lazyload"
                data-product-id={props.pid}
                data-product-title={props.title}
                width="500"
                height="750"
                alt={props.thumb_alt ? props.thumb_alt : props.title}
              />
            )}
            {!loading && imagesForVariant && imagesForVariant.length > 1 && (
              <img
                className="hover-image lazyload"
                alt={props.thumb_alt ? props.thumb_alt : props.title}
                width="500"
                height="750"
                data-product-id={props.pid}
                data-product-title={props.title}
                src={imagesForVariant[1]
                  .replace('_large', '')
                  .replace('_600x', '')
                  .replace('.jpg', '_500x750_crop_center.jpg')
                  .replace('.webp', '_500x750_crop_center.webp')}
              />
            )}
          </a>

          <ProductBadge tags={props.tags} />

          {originalProductUrl && (
            <div className="ProductTile__btn-quickviewWrapper">
              <div
                className="ProductTile__btn-quickview"
                data-quick-view-button
                href={`${newProductUrl}${productHash}`}
                data-is-rec={props.isRec}
                data-pid={props.pid}
                data-id={props.variant_id}
                data-product-id={props.pid}
                data-title={props.title.replace('PLACEHOLDER - ', '').replace('CLEARANCE - ', '')}
              >
                <div
                  className="ProductTile__gtm-click"
                  data-pid={props.pid.split('?')[0]}
                  data-id={props.variant_id}
                  data-product-id={props.pid}
                  data-title={props.title.replace('PLACEHOLDER - ', '').replace('CLEARANCE - ', '')}
                ></div>
                <i className="far fa-eye"></i>
                <span>&nbsp;</span>
                <span>Quick Shop</span>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="ProductTile__info">
        <div className="ProductTile__color-swatch">
          {numColors > 0 &&
            availableColors.slice(0, 5).map((color, i) => {
              const colorName = color.replace(' ', '_').toLowerCase();
              // const ind = props.options.Color.indexOf(color);
              // const styleNumber = props.options.Barcode[ind] ? props.options.Barcode[ind] : null;
              let styleNumber = getFirstVariantWithColorBarcode(color);
              if (styleNumber === undefined) {
                styleNumber = getFirstVariantImageWithBarcodeInd(color);
              }

              const swatch = props.product_type[0] && props.product_type[0].indexOf('GIVEX') > -1 ? 'GCS' : 'SWT';

              const bgUrl = loading
                ? 'none'
                : `url('https://cdn.shopify.com/s/files/1/0070/8853/7651/t/8/assets/${styleNumber}_${swatch}_48x48_crop_center.jpg?v=${window.theme.swatches_updated_at}')`;
              const style = {
                backgroundImage: bgUrl,
              };

              const firstVariant = getFirstVariantWithColor(color);
              const firstVariantId = firstVariant.id;

              let isActive = '';
              let onlyOneSwatch = '';

              if (i === 0 && numColors > 1) {
                isActive = 'active';
              } else {
                isActive = '';
              }

              if (numColors === 1) {
                onlyOneSwatch = 'disableActive';
              }
              if (clearanceProductData) {
                const parentHandle = clearanceProductData.handle;
                const parentVariantId = clearanceProductData.variant_map[firstVariantId];

                return (
                  <a
                    className={`ProductTile__color-swatch-item avail isp-product-color-swatch isp-product-color-swatch-${colorName} ${isActive} ${onlyOneSwatch}`}
                    key={`ProductTile-${props.id}-${color}`}
                    href={`/products/${parentHandle}?variant=${parentVariantId}${
                      props.recToken ? `&recToken=${props.recToken}` : ''
                    }`}
                    target="_self"
                    title={color}
                    style={style}
                    role="button"
                    aria-label={`Select: ${color} color`}
                    tabIndex={0}
                    onMouseOver={(e) => handleVariantColorMouseOver(e, color)}
                    onClick={(e) => {
                      if (window.outerWidth > 767) {
                        return;
                      }

                      e.preventDefault();
                      handleVariantColorMouseOver(e, color);
                    }}
                  />
                );
              } else if (checkSoldOutClearanceColors(color)) {
                return (
                  <a
                    className={`ProductTile__color-swatch-item check-swatch isp-product-color-swatch isp-product-color-swatch-${colorName} ${isActive} ${onlyOneSwatch}`}
                    data-url-test={`${newProductUrl}`}
                    target="_self"
                    key={`ProductTile-${props.id}-${color}`}
                    href={`${newProductUrl.split('?')[0]}?variant=${firstVariantId}${
                      props.recToken ? `&recToken=${props.recToken}` : ''
                    }`}
                    title={color}
                    style={style}
                    role="button"
                    aria-label={`Select: ${color} color`}
                    tabIndex={0}
                    onMouseOver={(e) => handleVariantColorMouseOver(e, color)}
                    onClick={(e) => {
                      if (window.outerWidth > 767) {
                        return;
                      }
                      e.preventDefault();
                      handleVariantColorMouseOver(e, color);
                    }}
                  />
                );
              } else {
                return null;
              }
            })}

          {numColors > 5 && <span className="ProductTile__color-swatch-count"> +{numColors - 5}</span>}
        </div>

        {props.reviewsCount > 0 && <ProductTileReviews review={props.review} />}

        {!props.isMobile && (
          <div
            className="yotpo bottomLine yotpo-small"
            data-appkey={yotpo_key}
            data-domain={window.location.hostname}
            data-product-id={props.pid}
            data-product-models={props.id}
            data-name={props.title}
            data-url={`https://${window.location.hostname}/products/${props.handle}`}
            data-image-url={currentThumbUrl}
            data-description=""
            data-bread-crumbs={props.tags}
          ></div>
        )}
      </div>

      <div className="ProductTile__info ProductTile__info--price">
        <p className="ProductTile__title" data-product-tile-title>
          <a href={newProductUrl}>{productTitle}</a>
        </p>
        <div className="ProductTile__price-row">
          {priceContainer}
          {props.isMobile && (
            <div
              className="yotpo bottomLine yotpo-small"
              data-appkey={yotpo_key}
              data-domain={window.location.hostname}
              data-product-id={props.pid}
              data-product-models={props.id}
              data-name={props.title}
              data-url={`https://${window.location.hostname}/products/${props.handle}`}
              data-image-url={currentThumbUrl}
              data-description=""
              data-bread-crumbs={props.tags}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

ProductTile.defaultProps = {
  title: 'No title provided',
  styleNumbers: {},
  variants: [],
  pid: '',
  isRec: false,
  narrowColorFamilies: [],
  shouldReportClickToAdmind: true,
  product_images: [],
  mobileStackStars: false,
};

export default ProductTile;
